import apiClient from "./client";

// All generate* functions accept an optional `templateId` so the Reports page
// can pick a specific Published template when more than one exists for a type.

function withTemplate(params, templateId) {
  if (templateId != null) params.append("templateId", String(templateId));
  return params;
}

export async function generateInspectionReport(inspectionId, templateId = null) {
  const params = withTemplate(new URLSearchParams(), templateId);
  const qs = params.toString() ? `?${params}` : "";
  const response = await apiClient.get(`/reports/inspection/${inspectionId}/findings${qs}`, {
    responseType: "blob",
  });
  return response;
}

export async function generateWorkOrderReport(workOrderId, templateId = null) {
  const params = withTemplate(new URLSearchParams(), templateId);
  const qs = params.toString() ? `?${params}` : "";
  const response = await apiClient.get(`/reports/workorder/${workOrderId}${qs}`, {
    responseType: "blob",
  });
  return response;
}

export async function generateFindingReport(findingId, templateId = null) {
  const params = withTemplate(new URLSearchParams(), templateId);
  const qs = params.toString() ? `?${params}` : "";
  const response = await apiClient.get(`/reports/finding/${findingId}${qs}`, {
    responseType: "blob",
  });
  return response;
}

export async function generateWorkOrderSummaryReport(startDate, endDate, templateId = null) {
  const params = withTemplate(new URLSearchParams({ startDate, endDate }), templateId);
  const response = await apiClient.get(`/reports/work-order-summary?${params}`, {
    responseType: "blob",
  });
  return response;
}

export async function generatePlannedWorkReport(startDate, endDate, assignedTo = null, templateId = null) {
  const params = new URLSearchParams({ startDate, endDate });
  if (assignedTo) params.append("assignedTo", assignedTo);
  withTemplate(params, templateId);
  const response = await apiClient.get(`/reports/planned-work?${params}`, {
    responseType: "blob",
  });
  return response;
}

export async function generateWorkOrderStatusReport(templateId = null) {
  const params = withTemplate(new URLSearchParams(), templateId);
  const qs = params.toString() ? `?${params}` : "";
  const response = await apiClient.get(`/reports/work-order-status${qs}`, {
    responseType: "blob",
  });
  return response;
}

export async function generateAssetHistoryReport(assetId, templateId = null) {
  const params = withTemplate(new URLSearchParams(), templateId);
  const qs = params.toString() ? `?${params}` : "";
  const response = await apiClient.get(`/reports/asset/${assetId}/history${qs}`, {
    responseType: "blob",
  });
  return response;
}
